import React, { FC, useRef } from 'react';
import { Link } from 'react-router-dom';
import cs from 'classnames';
import { useMenuCategoryGroups } from '../../hooks/useMenuCategoryGroups';

import s from './MegaMenu.scss';
import { useTemplatesPageUI } from '../../contexts/TemplatesPageUIContext';

interface MegaMenuProps {
  onCategoryClick: (slug: string) => void;
}
export const MegaMenu: FC<MegaMenuProps> = ({ onCategoryClick }) => {
  const menuCategoryGroups = useMenuCategoryGroups();
  const { isCategoriesMenuOpen } = useTemplatesPageUI();
  const contentRef = useRef<HTMLDivElement>(null);

  return (
    <div className={cs(s.container, { [s.open]: isCategoriesMenuOpen })}>
      <div className={s.content} ref={contentRef}>
        {menuCategoryGroups.map(({ title, categories }, index) => (
          <div className={s.bucketWrapper} key={title}>
            <div className={s.bucket}>
              <div className={s.title}>{title}</div>
              <ol
                className={cs(s.list, {
                  [s.twoColumn]: categories.length > 5 && index != 2,
                  [s.twoColumnNew]: categories.length > 8 && index === 2,
                })}
              >
                {categories.map(({ label, url, slug, isActive }) => (
                  <li className={s.item} key={slug}>
                    <Link
                      to={url}
                      className={cs(s.link, { [s.active]: isActive })}
                      onClick={() => onCategoryClick(slug)}
                      data-hook={`mega-menu-category-link-${slug}`}
                    >
                      <span className={s.linkLabel} data-text={label}>
                        {label}
                      </span>
                    </Link>
                  </li>
                ))}
              </ol>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
